// Packages
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

// Components
import Container from 'components/BTDUI/Container';
import Header from 'components/Header';
import Footer from 'components/Footer';

const UserViewLayout = ({ children }) => {

	return (
		<div className='UserViewLayout'>
			
			<Header/>

			<Container>

				<Link className='blue opacity' to='/users'>Users {'>'}</Link> 

				{children}

			</Container>

			<Footer/>
        </div>
	)
}

UserViewLayout.propTypes = {
	children: PropTypes.node,
}

UserViewLayout.defaultProps = {
	children: null,
}

export default UserViewLayout;